import { BACKEND_DOMAIN } from '../../constants/Branding';
import { getBrandDomain } from '../../util/stringUtil';

export const DevUrlsMap = {
  REACT_APP_REST_API_URL: `https://stage-api.quickexch.com/api/v1`,
  REACT_APP_REST_API_V2_URL: `https://stage-api.quickexch.com`,
  REACT_APP_REST_REPORTING_API_URL: `https://stage-reporting.quickexch.com`,
  REACT_APP_WEBSOCKET_URL_PUSH_NOTIFICATIONS: `https://stage-reporting.quickexch.com/push-notifications`,
  BINARY_WEBSOCKET_URL: `https://feed.mysportsfeed.io/hypex-ws`,
  REACT_APP_REST_AGPAY_URL: `https://dev-agpay.quickexch.com`,
};

export const ProdUrls = {
  REACT_APP_REST_API_URL: `https://api.${BACKEND_DOMAIN}/api/v1`,
  REACT_APP_REST_API_V2_URL: `https://api.${BACKEND_DOMAIN}`,
  REACT_APP_REST_REPORTING_API_URL: `https://reporting.${BACKEND_DOMAIN}`,
  REACT_APP_WEBSOCKET_URL_PUSH_NOTIFICATIONS: `https://reporting.${BACKEND_DOMAIN}/push-notifications`,
  BINARY_WEBSOCKET_URL: `https://feed.mysportsfeed.io/hypex-ws`,
  REACT_APP_REST_AGPAY_URL: `https://agpay.${BACKEND_DOMAIN}`,
};

export const EnvUrlsMap = {
  development: DevUrlsMap,
  stage: DevUrlsMap,
  production: ProdUrls,
};

export function getBaseUrl(env: string, url: string) {
  return EnvUrlsMap[env][url];
}
